/* eslint-disable */
import { Middleware } from "@sa/rep-common";
import { DataFlowProcessingState } from "@sa/rep-core";
import { ServiceProvider } from "@sa/rep-services-provider";
import { REPORT_ID } from "../constants";

export const slide35DataflowMiddlewares = (serviceProvider: ServiceProvider) => {
  return async function(input, next) {
    if ([REPORT_ID].includes(input.reportId)) {
    }
    return next(input);
  } as Middleware<DataFlowProcessingState>;
};
